import React, { useId } from "react";
import PropTypes from "prop-types";

const PostCancelIcon = ({ size = 22, className = "" }) => {
    const gradientId = useId();
    const fillId = `${gradientId}-post-cancel-fill`;
    const strokeId = `${gradientId}-post-cancel-stroke`;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 22 22"
            fill="none"
            aria-hidden="true"
            className={className}
        >
            <defs>
                <radialGradient id={fillId} cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(11 11) scale(10)">
                    <stop stopColor="rgba(255, 149, 197, 0.32)" />
                    <stop offset="1" stopColor="rgba(255, 149, 197, 0)" />
                </radialGradient>
                <linearGradient id={strokeId} x1="5" y1="17" x2="17" y2="5" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF8AA8" />
                    <stop offset="1" stopColor="#B38CFF" />
                </linearGradient>
            </defs>
            <circle cx="11" cy="11" r="10" fill={`url(#${fillId})`} />
            <path
                d="M7.2 7.2L14.8 14.8M14.8 7.2L7.2 14.8"
                stroke={`url(#${strokeId})`}
                strokeWidth="1.6"
                strokeLinecap="round"
            />
        </svg>
    );
};

PostCancelIcon.propTypes = {
    size: PropTypes.number,
    className: PropTypes.string,
};

PostCancelIcon.defaultProps = {
    size: 22,
    className: "",
};

export default PostCancelIcon;
